import { Expose } from 'class-transformer'

export class ProductImage {
  @Expose({ name: 'image' })
  url: string = ''
}
